import Button from '@/features/shared/Button';
import { BlueArrowIcon } from '@/features/shared/Icons';
import { Theme } from '@/utils/constants';
import React from 'react';
import useStyles from './LinkItem.styles';

export type LinkItemProps = {
  link: LinkType;
};

const LinkItem = ({ link }: LinkItemProps) => {
  const classes = useStyles();

  const externalLinkDatalayerProps = {
    'data-datalayer-type': 'external_link',
  };

  return (
    <div className={classes.root}>
      <Button
        className={classes.link}
        variant="text"
        theme={Theme.dark}
        endIcon={<BlueArrowIcon direction="right" />}
        link={link}
        data-datalayer-ignore-cta="true"
        {...(link.openInNewWindow ? externalLinkDatalayerProps : {})}
      >
        {link.displayText}
      </Button>
    </div>
  );
};

export default LinkItem;
